import React, { useRef } from 'react';
import { useParams } from 'react-router-dom';
import useFetchJSONContent from '../../../hooks/use-fetch-json';
import { Button, ClassesBox } from './styles';
import ISubjects from '../../../@types/ISubjects';

type Props = {
  typeTheme: string;
  onClick: () => void;
};

export interface IPage {
  id: number;
  slug: string;
  sections: string[];
}

export default function Chapters({ typeTheme, onClick }: Props) {
  const { subject, page, section } = useParams();
  const boxRef = useRef<HTMLDivElement>(null);
  const subjectMetadata = useFetchJSONContent<ISubjects[]>('content/html/subjects.json', 'sections');
  const pagesMetadata = subjectMetadata?.find((item) => item.slug === subject)?.children;
  const pageMetadata = pagesMetadata?.find((pageMetadata) => pageMetadata.slug === page);

  if (!subject || !page) return null;

  if (!pageMetadata?.children || pageMetadata.children.length === 0) {
    return null;
  }

  return (
    <ClassesBox ref={boxRef}>
      {pageMetadata.children.map((subpage) => {
      const { title, slug } = subpage;

      return (
        <Button
          key={slug}
          $active={slug === section}
          $textcolor={10}
          $subject={typeTheme}
          $color={40}
          $hovercolor={70}
          to={`/${subject}/${page}/${slug}`}
          onClick={onClick}
        >
          {title}
        </Button>
      );
      })}
    </ClassesBox>
  );
}
